<template>
  <nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-semi-light app-topbar">
    <div class="topbar-inner">
      <a class="topbar-menu-btn nav-menu-main menu-toggle" href="#" @click.prevent="toggleSidebar">
        <span class="burger-line"></span>
        <span class="burger-line"></span>
        <span class="burger-line"></span>
      </a>
      <span class="topbar-brand"></span>
      <img src="/images/logo/logo.png" class="topbar-logo" alt="Medicater" />
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Topbar',
  methods: {
    toggleSidebar: function () {
      var $body = $('body')
      if ($body.hasClass('menu-open')) {
        $body.removeClass('menu-open').addClass('menu-hide')
      } else {
        $body.removeClass('menu-hide menu-collapsed').addClass('menu-open')
      }
    },
    logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.app-topbar {
  background: #05aceb !important;
 /* background: linear-gradient(90deg, #1a587b 0%, #1a587b 100%) !important; */
      box-shadow: 0 2px 16px rgba(141, 193, 244, 0.47) !important;
  border: none !important;
  height: 56px !important;
  min-height: 56px !important;
}

.topbar-inner {
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 0 16px;
  gap: 14px;
}

.topbar-menu-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 36px;
  height: 36px;
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
  text-decoration: none;
  flex-shrink: 0;
}

.topbar-menu-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.burger-line {
  display: block;
  width: 20px;
  height: 2px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 2px;
  transition: background 0.15s;
}

.topbar-logo {
  height: 28px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  flex-shrink: 0;
}

.topbar-brand {
  flex: 1;
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  text-align: center;
}
</style>
